import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import apiClient from './apiClient'
import TheMask from 'vue-the-mask'
import '@fortawesome/fontawesome-free/css/fontawesome.css';
import '@fortawesome/fontawesome-free/css/solid.css';

// Mantém as rotas legadas com hash funcionando após a migração para history mode.
// A URL pública da consulta continua sendo tratada pela aplicação na raiz.
if (window.location.hash.startsWith('#/') && window.location.hash !== '#/consulta-contatos') {
  const rotaLegada = window.location.hash.substring(1)
  window.history.replaceState({}, '', rotaLegada)
}

const app = createApp(App)

app.use(TheMask)

app.config.globalProperties.$axios = apiClient

app.use(store)
app.use(router)
app.mount('#app')
